import React from 'react'
import PropTypes from 'prop-types'

function CurrentYearLine ({ date }) {
  return <div className="current-year-line">
    Current year database - as of {date}
  </div>
}

CurrentYearLine.propTypes = {
  date: PropTypes.string
}

export default CurrentYearLine



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/components/CurrentYearLine.js